import classNames from 'classnames';
import { CardRequisite } from '../top-info';
import styles from './index.module.sass';
import { IRecipeComponent } from '@/widgets/recipe/types';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';
import { toReadable } from '@/modules/mixing/helpers/to-readable.helper';
import { IComponentParam } from '@/modules/mixing/ts';
import { warehouseModel } from '@/entities/warehouse';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import { WarehouseTypes } from '@/modules/warehouses/ts';
import { useStore } from 'effector-react';

export const ComponentCard = ({
  variant,
  data,
  params,
  i,
  price,
}: {
  variant: 'blue' | 'red';
  data?: { id: string, warehouse_id: number, weight: number }[];
  params?: IComponentParam;
  i: number;
  price?: number;
}) => {
  const activeWarehouse = useStore($selectedRecipeStore);
  const isWarehouseTypeSleeve = activeWarehouse?.type && Number(activeWarehouse.type) as unknown as WarehouseTypes === warehouseModel.WAREHOUSE_TYPES.sleeve;

  return (
    <div
      className={classNames(styles.root, variant === 'blue' ? styles.blue : styles.red)}
    >
      <div className={styles.topLine}>
        <span className={styles.title}>компонент {i+1} </span>
        <span className={styles.sleeve}>
          {isWarehouseTypeSleeve
          ? declineWord(Number(data?.length), ['рукавов', 'рукав', 'рукава'])
          : declineWord(Number(data?.length), ['объёмов', 'объём', 'объёма'])}
        </span>
        <div className={styles.weight}>
          <span className={styles.label}>вес</span>
          <span className={styles.value}>{toReadable(data?.reduce((acc, curr) => acc + curr.weight, 0))} т</span>
        </div>
      </div>
      <div className={styles.midLine}>
        <CardRequisite className={styles.craParam} label="клейковина" value={params?.gluten || 0} sign="%" />
        <CardRequisite className={styles.craParam} label="влажность" value={params?.humidity || 0} sign="%" />
        <CardRequisite className={styles.craParam} label="ИДК" value={params?.idk || 0} sign={""} />
        <CardRequisite className={styles.craParam} label="число падения" value={params?.cp || 0} sign="сек" />
        <CardRequisite className={styles.craParam} label="протеин" value={params?.protein || 0} sign="%" />
        <CardRequisite className={styles.craParam} label="натура" value={params?.nature || 0} sign="г/л" />
      </div>
      <div className={styles.bottomLine}>
        <span className={styles.label}>стоимость компонента</span>
        <span className={styles.value}>{toReadable(price || 0)} ₽</span>
      </div>
    </div>
  );
};
